import React, { useState, useEffect } from "react";
import {
  NavLink
} from "react-router-dom";
import { Helmet } from "react-helmet";
// import { NavHashLink as Link } from "react-router-hash-link";

import "react-tippy/dist/tippy.css";
import logo from "./images/Logo provincie Zuid-Holland.svg";
import slogan from "./images/Krachtig Zuid-Holland.svg";
import ogimage from "./images/planmer-zuid-holland.jpg";

import menuitemsData from "./data/menuEnergietransitie";
import bronnenlijst from "./data/energietransitie/bronnenlijst"

const PlanMER = ({ title, content, sources_used, prev, next }) => {

    const meta_title = title !== undefined ? title + " • Milieueffectrapportage Module Energietransitie • Provincie Zuid-Holland" : "Milieueffectrapportage Module Energietransitie • Provincie Zuid-Holland"
    const description = "Onderdeel '"+ title +"' uit de Milieueffectrapportage Module Energietransitie van de provincie Zuid-Holland"

    const [navbarOpen, setNavbarOpen] = useState(false)
    const [versionbarOpen, setVersionbarOpen] = useState(false)

    const handleToggle = () => {
      setNavbarOpen(!navbarOpen)
      setScroll(false);
    }    

    const resetScroll = () => {
      setScroll(false);
    }
    
    /* Menu scroll*/

    const [scroll, setScroll] = useState(false);
    useEffect(() => {

      window.addEventListener("scroll", () => {

        var elmMenu = document.getElementById("sidemenu").firstChild;
        var elmContent = document.getElementById("planMerContent").firstChild;

        if( elmMenu.offsetHeight <= elmContent.offsetHeight ) {
          setScroll(window.scrollY > 202);
        }

      });

    }, []);

    const handleVersion = () => {
      setVersionbarOpen(!versionbarOpen)
    }
    
    var bronnenLijst = "1";

    if( sources_used ) {
      bronnenLijst = sources_used.map(function(source_id){
        var bronLijst = bronnenlijst.bronnen.filter(bron => parseInt(bron.id) === source_id).map(function(filteredBron){
          var bronAuteur = filteredBron.auteur;
          var bronTitel = filteredBron.titel ? `, ${filteredBron.titel}` : '';
          var bronJaartal = filteredBron.jaar ? ` (${filteredBron.jaar})` : '';
          var bronUrl = filteredBron.link ? `${filteredBron.link}` : '';          
          var bronPagina = filteredBron.pagina ? `, ${filteredBron.pagina}` : '.';

          return (
            <div className="source">
              <span className="sourceIndex"><sup>{filteredBron.id}</sup></span>
              <span className="sourceName">
                {bronAuteur}<i>{bronTitel}</i>{bronJaartal}
                { bronUrl !== '' && (
                  <>, <a href={filteredBron.link} target="_blank" rel="noreferrer">{bronUrl}</a>
                  </>
                )
                }
                {bronPagina}
              </span>
            </div>                              
              
            )
        })

        return(bronLijst);
      });
    }
    


  return (
    <div className="container">
      <div className={`overlay ${versionbarOpen ? "  show" : ""}`}></div>

      <Helmet>
        <title>{meta_title}</title>
        <meta name="description" content={description} />
        <meta property="og:image" content={ogimage} />
      </Helmet>
      <header>
        <div className="wrapperFull">
          <a href="/" className="logo">
            <img src={logo} alt="Provincie Zuid-Holland" />
          </a>
          <div className="headerMenu">
            {/* <div className="login"><a href="/admin" target="_blank"><i className="far fa-sign-in"></i>&nbsp;&nbsp;Inloggen</a></div> */}
          </div>
        </div>
      </header>
      <div className="pageTitle">
        <div className="wrapper">
          <div className="row">
            <div className="col-6">
              <h1>Milieueffectrapportage Module Energietransitie</h1>              
              <button className="versienummer" onClick={handleVersion}>Versie 04-10-2022 (Vastgesteld GS)</button>
              <div className={`versies__menu ${versionbarOpen ? "  show" : ""}`}>
                <div className="close" onClick={handleVersion}>Sluit</div>
                <h3>Versies</h3>
                <NavLink to="/energietransitie/samenvatting" className="current">Versie 04-10-2022 (Vastgesteld GS)</NavLink><br />
                <NavLink to="/energietransitie-05-05-2022/samenvatting">Versie 17-05-2022  (Definitief Ontwerp GS)</NavLink>              
              </div>            
            </div>
          </div>
        </div>
      </div>
      <div className="menuTrigger btn secundair" onClick={handleToggle}>Inhoudsopgave</div>
      <div className="main">
        <div className="wrapper">
          <div className="row">
            <div className= {`col-2 menu ${navbarOpen ? " showMenu" : ""}`} id="sidemenu" >
              <div className={`sidemenu  ${scroll ? "sticky" : "not-sticky"}`}  >
                <strong>Milieueffectrapportage Module Energietransitie</strong>

                <nav>
                  <ul>
                    {menuitemsData.menu.map((menu) => {
                      if (menu.children.length !== 0) {

                        return (
                          <li key={menu.link}>
                            <NavLink to={menu.link} onClick={handleToggle}>{menu.title}</NavLink>
                            <ul>
                              {menu.children.map((menuChild) => {
                                // if (menuChild.link.includes("#")) {
                                //   return (
                                //     <li key={menuChild.link}>
                                //       <HashLink {...menuChild} />
                                //     </li>
                                //   );
                                // }
                                if (menuChild.children.length !== 0) {
                                  
                                  return (
                                    <li key={menuChild.link}>
                                      <NavLink to={menuChild.link} onClick={handleToggle}>
                                        {menuChild.title}
                                      </NavLink>
                                      {menuChild.children.map((menuSuperChild) => {
                                        
                                        // console.log(menuSuperChild)

                                        return (
                                        
                                          <ul>
                                            <li key={menuSuperChild.link}>
                                              <NavLink to={menuSuperChild.link} onClick={handleToggle}>
                                                {menuSuperChild.title}
                                              </NavLink>
                                            </li>
                                          </ul>
                                        )

                                      })}
                                    </li>
                                  );
                                }

                                return (
                                  <li key={menuChild.link}>
                                    <NavLink to={menuChild.link} onClick={handleToggle}>
                                      {menuChild.title}
                                    </NavLink>
                                  </li>
                                );

                              })}
                            </ul>
                          </li>
                        );
                      } else {

                        // Geen kinderen niveau 1
                        return (
                          <li key={menu.link}>
                            <NavLink to={menu.link} onClick={handleToggle}>{menu.title}</NavLink>
                          </li>
                        );
                      }
                    })}
                  </ul>
                </nav>             
              </div>
            </div>
            <div className="col-4 planMerContent" id="planMerContent">
              <div>
                <h2>{title}</h2>
                <div>{content}</div>


                  {bronnenLijst !== "1" && (                    
                    <div className="sources">
                        <h5>Voetnoot</h5>
                        {bronnenLijst}
                    </div>
                  )}

                
                  <div className="pagination">
                    {prev !== '' && prev !== undefined && (
                      <div className="pagination_prev">
                        <NavLink to={prev} onClick={resetScroll}>Vorige</NavLink>
                      </div>
                    )}

                    {next !== '' && next !== undefined && (
                      <div className="pagination_next">
                        <NavLink to={next} onClick={resetScroll}>Volgende</NavLink>
                      </div>
                    )}
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <div className="wrapper">
          <div className="motto">
            <img src={slogan} alt="Krachtig Zuid-Holland" />
          </div>
        </div>
      </footer>
    </div>
  );
};

// const HashLink = ({ link, title }) => {
//   const scrollWithOffset = (el) => {
//     const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
//     const yOffset = -80;
//     window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
//   };

//   return (
//     <Link to={link} smooth scroll={scrollWithOffset}>
//       {title}
//     </Link>
//   );
// };

export default PlanMER;
